/**
 * 작업완료보고서 규칙. 견적서와 **표 구조가 다르다** — 금액이 아니라 "무엇을 했는가"와
 * "확인받았는가"가 문서의 뼈대다. 그래서 `quoteRules` 와 합치지 않고 따로 둔다.
 *
 * 이 자리를 노리는 이유: 실측 경쟁이 가장 얕다 (App Store 한국 검색 결과 **앱 1개** —
 * 견적서 12·거래명세서 5·부가세계산기 47과 비교). 그리고 **유료 상품(L1)의 두 번째 문서가
 * 정확히 이것**이라 무료→유료 다리가 가장 짧다 (docs/goals §4-b).
 */

export interface WorkItem {
  /** 한 일 */
  description: string
  /** 완료 여부 — 미완이면 보고서에 '일부'로 남는다. 거짓 보고를 만들지 않는다 */
  done: boolean
}

export interface ReportInput {
  /** 시공자(우리) */
  contractor: string
  /** 고객·현장 */
  client: string
  /** 현장 주소·위치 (선택) */
  site: string
  /** 작업일 YYYY-MM-DD */
  workedOn: string
  items: WorkItem[]
  /** 특이사항 */
  note: string
}

/** 실제로 적힌 작업만 (빈 줄 제거) */
export function usableWork(items: readonly WorkItem[]): WorkItem[] {
  return items.filter((item) => item.description.trim() !== '')
}

export type ReportStatus = 'none' | 'partial' | 'complete'

/**
 * 완료 상태. **전부 체크됐을 때만 '완료'** 다 — 하나라도 남으면 '일부 완료'로 적는다.
 * 문서가 사실과 다르면 그 문서로 정산할 때 다툼이 된다.
 */
export function reportStatus(items: readonly WorkItem[]): ReportStatus {
  const rows = usableWork(items)
  if (rows.length === 0) return 'none'
  return rows.every((item) => item.done) ? 'complete' : 'partial'
}

export function statusLabel(status: ReportStatus): string {
  if (status === 'complete') return '작업 완료'
  if (status === 'partial') return '일부 완료'
  return ''
}

/** 완료/전체 (예: "3/4") */
export function progressText(items: readonly WorkItem[]): string {
  const rows = usableWork(items)
  if (rows.length === 0) return ''
  return `${rows.filter((r) => r.done).length}/${rows.length}`
}
